<template>
  <div class="fragment">


    <div v-for="(permanentVinylItem, index) in FBM.data.PermanentVinyls" :key="index">
      <div class="order-create__title-horizontal"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <TitleHorizontal
            :value="' #' + (parseInt(index) + 1)"
            :rightBtn="true"
            :rightBtnType="'delete'"
            :rightBtnText="$t('common_delete.localization_value.value')"
            @rightBtnClick="FBM.removePermanentVinyl(parseInt(index))"
        />
      </div>

      <PermanentVinylItem
          :FBM="FBM"
          :permanentVinylItem="permanentVinylItem"
          :permanentVinylsCount="FBM.data.Engravings.length"
          :permanentVinylColorOptions="permanentVinylColorOptions"
          :index="index"
          @changeQuantity="(customization, val) => $emit('changeQuantity', customization, val)"
      />

    </div>

    <div class="custom-row">
      <div class="custom-col mb-0">
        <div class="order-create__product-btn add-product-btn-wrap mb-2">
          <div class="order-create__product-btn-i add-product-btn site-link"
               @click="FBM.addPermanentVinyl()"
          >
            <div class="admin-edit" @click="editTranslate(['common_AddNew'])"></div>
            +  {{$t('common_AddNew.localization_value.value')}} {{$t('calculatorEngraving_permanentVinyl.localization_value.value')}}
          </div>
        </div>
      </div>
    </div>




  </div>
</template>

<script>
import TitleHorizontal from "@/components/coreComponents/TitleHorizontal/TitleHorizontal";
import PermanentVinylItem
  from "@/components/modules/OrdersFBMModule/components/components/chunks/EngravingFile/components/PermanentVinylItem/PermanentVinylItem";

export default {
  name: "PermanentVinyl",
  components: {PermanentVinylItem, TitleHorizontal, },

  props: {
    FBM: Object,
    permanentVinylColorOptions: Array,
  },



}
</script>

<style scoped>

</style>